import AdminCustomerVasps from './AdminCustomerVasps'

export default AdminCustomerVasps
